import { render, staticRenderFns } from "./pwdlost-confirm.vue?vue&type=template&id=6703f2c4&scoped=true&"
import script from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
export * from "./pwdlost-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./main.css?vue&type=style&index=0&id=6703f2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6703f2c4",
  null
  
)

export default component.exports